import React, {useRef} from 'react'
import { faCheck, faSearch } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { mainAxios } from '../../../services/mainAxios'
import Loader from '../../Layout/Loader'
import { toast } from 'react-toastify'
import { useTranslation } from "react-i18next";
import { useHistory } from 'react-router-dom';
import PhoneInput from 'react-phone-input-2'
import { compactSelect } from '../../../design/selectStyle'
import Select from "react-select"

const AddCompany = () => {
    const { t } = useTranslation('translations');
    const [inputClass, setInputClass] = React.useState("");
    const history=useHistory();

    const [state, setState] = React.useState({
        active: true,
        name: "",
        nuis: "",
        type: "",
        email: "",
        phoneNumber: "",
        websiteUrl: "",
        companyAddress: "",
        issuerInVat: true,
        invoicesNr: 0,
        certificate: {
            file: null,
            name: null,
            type: "PKCS12",
            alias: "",
            password: "",
            keyPass: ""
        },
        beginningDate:"",
        expirationDate: "",
        companyCategory:""
    })
    const [sellerInputClass, setSellerInputClass] = React.useState("");
    const [seller, setSeller] = React.useState("");
    const [loading, setLoading] = React.useState(false)
    const formRef = useRef()

    const companyCategories=[
        {label:"Banka /Institucione Financiare",value:"Banka"},
        {label:t("company.educational"),value:"Institucione Arsimore"},
        {label:t("company.stateInst"),value:"Institucione shteterore"},
        {label:t("company.construction"),value:"Kompani ndertimi"},
        {label:"OJF",value:"OJF"},
        {label:"Real Estate",value:"Real Estate"},
        {label:t("company.insurance"),value:"Siguracione"},
        {label:t("company.accounting"),value:"Studio Kontabel"},
        {label:t("company.health"),value:"Shendetesore"},
        {label:"Sherbime Editoriale",value:"Sherbime editoriale"},
        {label:t("invoice.other"),value:"Tjeter"},

    ]

    const addCompany = () => {
        setLoading(true)
        const {beginningDate,expirationDate}=state
        // if(beginningDate.length==0 || expirationDate.length==0){
        //     toast.warning(t("toast.dateSubscriptionEmpty"), {
        //         containerId: "all_toast",
        //       });
        //       setLoading(false)
        //     return
        // }

        if (!state.email) {
            toast.warning(t("toast.emailError"), {
                containerId: "all_toast",
            });
            setLoading(false);
            return;
        }
        
        if (!state.phoneNumber) {
            toast.warning(t("toast.phoneError"), {
                containerId: "all_toast",
            });
            setLoading(false);
            return;
        }
        

        if(state.nuis) state.nuis=state.nuis.trim()
        if(state.businessUnitCode) state.businessUnitCode=state.businessUnitCode.trim()

        mainAxios.post('apiEndpoint/saveOrUpdate', {
            object: "Company",
            content: {
                ...state
            }
        }).then(res => {
            setLoading(false)
            if(res?.data?.status === true) {
                const id=res?.data?.content?.[0]?.id
                if(id){
                    history.push('/companies/'+id)
                }
                toast.success(t(['toast.addCompany']), {
                    containerId: "all_toast"
                })
            }
        })
    }

    const handleCompanyInputs = (e, selectedKey, selectedValue) => {
        const key = selectedKey ?? (e.target.name ?? "")
        const value = selectedValue ?? (e.target.value ??  ""
)
        setState(state => ({
            ...state,
            [key]: value
        }))
    }
    const handleCertificate = (e) => {
        let file = e.target.files[0]

        if(file) {
            const reader = new FileReader();

            reader.onload = (readerEvent) => {
                let binaryString = readerEvent.target.result
                setState(state => ({
                    ...state,
                    certificate: {
                        ...state.certificate,
                        file: btoa(binaryString),
                        name: file.name
                    }
                }))
            }

            reader.readAsBinaryString(file)
        }
    }




    const handleSellerTaxPayerSearch = () => {
        let sellerNIPT = seller.split(" ").join("");
        setSeller(sellerNIPT);
          if (new RegExp("[a-zA-Z]{1}[0-9]{8}[a-zA-Z]{1}").test(sellerNIPT)) {
            setSellerInputClass("loading");
            mainAxios
              .post("apiEndpoint/search", {
                object: "GetTaxpayersRequest",
                value: sellerNIPT,
              })
              .then((res) => {
                if (res?.data?.status === true) {
                  if (res.data.content.length === 0) {
                    toast.warning(t(["toast.noTaxPayer"]), {
                      containerId: "all_toast",
                    });
                    setSellerInputClass("error");
                  } else {
                      const taxPayer = res.data.content[0];
                      let { name:sellerName, tin } = taxPayer;
                    //   if(tin)getBranchesFromCis({nuis:tin})
                    sellerName = sellerName ? sellerName.slice(0, 99) : null;
                    setState(state=>{
                        return {
                            ...state,
                            name:sellerName,
                            nuis:tin
                        }
                    })

                    setSellerInputClass("success");
                  }
                } else {
                  setSellerInputClass("error");
                }
              })
              .catch((e) => {
                setSellerInputClass("error");
              });
          } else {
            toast.error(t(["toast.incorrectNipt"]), { containerId: "all_toast" });
            setSellerInputClass("error");
          }
      };

      const handleSellerTaxPayerChange = (e) => {
        let value = e.target.value;

        setSeller(value);
        if (inputClass.length > 0) setSellerInputClass("");
      };

    return (
        <form onSubmit={addCompany} ref={formRef}>
            <div className="company-form">
                {/* Header (hidden inside the add-company dialog via CSS) */}
                <div className="company-form__header">
                    <h3 className="company-form__title">{t('company.addCompanyTitle')}</h3>
                </div>

                {/* NIPT Search */}
                <div className="company-form__section">
                    <div className="company-form__section-title">{t("navbar.search")} (NIPT)</div>
                    <div className="company-form__field" style={{maxWidth: '400px'}}>
                        <div className="company-form__search-group">
                            <input
                                name="seller"
                                type="text"
                                className={`company-form__input${sellerInputClass === "error" ? " border-danger" : sellerInputClass === "success" ? " border-success" : ""}`}
                                value={seller}
                                onChange={handleSellerTaxPayerChange}
                                style={{borderRadius: '8px 0 0 8px'}}
                            />
                            <span
                                className="company-form__search-group-btn"
                                onClick={handleSellerTaxPayerSearch}
                            >
                                <FontAwesomeIcon icon={faSearch} />
                            </span>
                        </div>
                        {sellerInputClass === "loading" && (
                            <div className="input-icon input-loader">
                                <Loader size="xs" />
                            </div>
                        )}
                    </div>
                </div>

                {/* Company Identity Fields */}
                <div className="company-form__section">
                    <div className="company-form__section-title">{t('company.companyInfo')}</div>
                    <div className="company-form__grid">
                        <div className="company-form__field">
                            <span className="company-form__label">
                                {t('company.name')} (Max 99) <span className="text-danger">*</span>
                            </span>
                            <input
                                type="text"
                                className="company-form__input"
                                name="name"
                                maxLength="99"
                                placeholder="Name"
                                value={state.name}
                                onChange={handleCompanyInputs}
                                required
                            />
                        </div>
                        <div className="company-form__field">
                            <span className="company-form__label">
                                NIPT <span className="text-danger">*</span>
                            </span>
                            <input
                                type="text"
                                className="company-form__input"
                                name="nuis"
                                placeholder="Company NIPT"
                                value={state.nuis.trim()}
                                onChange={handleCompanyInputs}
                                required
                            />
                        </div>
                        <div className="company-form__field">
                            <span className="company-form__label">{t('company.type')}</span>
                            <input
                                type="text"
                                className="company-form__input"
                                name="type"
                                placeholder="E.g 'Person Fizik'"
                                value={state.type}
                                onChange={handleCompanyInputs}
                            />
                        </div>
                        <div className="company-form__field">
                            <span className="company-form__label">{t("common.companyCategory")}</span>
                            <Select
                                styles={compactSelect}
                                name="companyCategory"
                                value={companyCategories.find((el) => el.value === state.companyCategory)}
                                options={companyCategories}
                                onChange={(option) => handleCompanyInputs(null, "companyCategory", option.value)}
                            />
                        </div>
                    </div>
                </div>

                {/* Contact Information */}
                <div className="company-form__section">
                    <div className="company-form__section-title">{t("company.contactInfo")}</div>
                    <div className="company-form__grid">
                        <div className="company-form__field">
                            <span className="company-form__label">
                                E-mail <span className="text-danger">*</span>
                            </span>
                            <input
                                type="email"
                                className="company-form__input"
                                name="email"
                                placeholder="Company Email"
                                value={state.email}
                                onChange={handleCompanyInputs}
                                required
                            />
                        </div>
                        <div className="company-form__field">
                            <span className="company-form__label">
                                {t("users.phone")} <span className="text-danger">*</span>
                            </span>
                            <PhoneInput
                                country="al"
                                inputStyle={{ width: "100%" }}
                                value={state?.phoneNumber ?? ""}
                                placeholder="E.g. '+355690000000'"
                                onChange={(value) => handleCompanyInputs(null, "phoneNumber", value)}
                            />
                        </div>
                        <div className="company-form__field">
                            <span className="company-form__label">{t("company.websiteUrl")}</span>
                            <input
                                type="text"
                                className="company-form__input"
                                name="websiteUrl"
                                placeholder="Website Url"
                                value={state?.websiteUrl}
                                onChange={handleCompanyInputs}
                            />
                        </div>
                        <div className="company-form__field">
                            <span className="company-form__label">{t("customers.address")}</span>
                            <input
                                type="text"
                                className="company-form__input"
                                name="companyAddress"
                                value={state?.companyAddress}
                                onChange={handleCompanyInputs}
                            />
                        </div>
                    </div>
                </div>

                {/* Certificate */}
                <div className="company-form__section">
                    <div className="company-form__section-title">Certificate</div>
                    <div className="company-form__grid">
                        <div className="company-form__field">
                            <span className="company-form__label">
                                Certificate <span className="text-danger">*</span>
                            </span>
                            <input
                                type="file"
                                className="company-form__input"
                                name="certificate"
                                onChange={handleCertificate}
                            />
                            {state.certificate.name && <small style={{color: '#999', fontSize: '12px'}}>{state.certificate.name}</small>}
                        </div>
                        <div className="company-form__field">
                            <span className="company-form__label">
                                Alias <span className="text-danger">*</span>
                            </span>
                            <input
                                type="text"
                                className="company-form__input"
                                name="certificate_alias"
                                placeholder="Certificate Alias"
                                value={state.certificate.alias}
                                onChange={(e) => {
                                    const value = e.target.value
                                    setState(state => ({...state, certificate: {...state.certificate, alias: value}}))
                                }}
                            />
                        </div>
                        <div className="company-form__field">
                            <span className="company-form__label">
                                Password <span className="text-danger">*</span>
                            </span>
                            <input
                                type="password"
                                className="company-form__input"
                                name="certificate_password"
                                placeholder="Certificate Password"
                                value={state.certificate.password}
                                onChange={(e) => {
                                    const value = e.target.value
                                    setState(state => ({...state, certificate: {...state.certificate, password: value}}))
                                }}
                            />
                        </div>
                        <div className="company-form__field">
                            <span className="company-form__label">
                                Key Password <span className="text-danger">*</span>
                            </span>
                            <input
                                type="password"
                                className="company-form__input"
                                name="keyPass"
                                placeholder="Key Password"
                                value={state.certificate.keyPass}
                                onChange={(e) => {
                                    const value = e.target.value
                                    setState(state => ({...state, certificate: {...state.certificate, keyPass: value}}))
                                }}
                            />
                        </div>
                    </div>
                </div>

                <div className="company-form__footer">
                    <button
                        type="button"
                        onClick={() => addCompany()}
                        disabled={loading}
                        className="company-form__save-btn"
                    >
                        {loading ? <Loader size="xs" color="white" /> : (
                            <>
                                <FontAwesomeIcon icon={faCheck} />
                                {t('common.save')}
                            </>
                        )}
                    </button>
                </div>
            </div>
        </form>
    )
}

export default AddCompany